import React from 'react';
import Header, { HeaderLeft } from 'layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';
import { useSelector } from 'react-redux';
import { RootState } from 'stores/store';
import { capitalizeFirstLetter } from 'helpers/helpers';
import Avatar from 'components/Avatar';
import { links } from 'helpers/urls';

const DashboardHeader = () => {
	const admin = useSelector((state: RootState) => state.auth.admin);
	return (
		<Header>
			<HeaderLeft>
				<div className='col d-flex align-items-center'>
					<div className='me-3'>
						<Avatar
							srcSet={`${links.galleryUrl}/${admin?.passport_photo}`}
							src={`${links.galleryUrl}/${admin?.passport_photo}`}
							size={48}
							color='primary'
						/>
					</div>
					<div>
						<div className='fw-bold fs-6 mb-0'>
							{capitalizeFirstLetter(
								`${admin?.firstname} ${admin?.othername} ${admin?.lastname}`,
							)}
						</div>
						<div className='text-muted'>
							<small>{admin?.roles?.[0].name ?? ''}</small>
						</div>
					</div>
				</div>
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DashboardHeader;
